
// Clients
export {
  RoleItem, RoleUser, RoleHome, RoleProject
} from '../../../clients/BackendAdminClient/nonsc-user-role'

// References
import {
  RoleItem, RoleUser, RoleHome, RoleProject
} from '../../../clients/BackendAdminClient/nonsc-user-role'

export class NonScUserRoleCommon {

  /** @type {RoleUser} */
  static user = {
    id        : null,
    firstName : null,
    lastName  : null,
    email     : null,
    mobileNo  : null
  }

  /** @type {RoleHome} */
  static home = {
    id        : null,
    addressNo : null
  }

  /** @type {RoleProject} */
  static project = {
    id    : null,
    code  : null,
    icon  : null,
    name  : null
  }

  /** @type {RoleItem} */
  static item = {
    id        : null,
    role      : null,
    user      : this.user,
    home      : this.home,
    project   : this.project,
    createdAt : null
  }
}



// WEBPACK FOOTER //
// ./src/features/nonsc/common/nonsc-user-role.common.js